import { useState, useEffect } from "react";

export const UseLocalStorage = (key = "theArray") => {
  const [isLocalStorage, setIsLocalStorage] = useState([]);

  useEffect(() => {
    function checkLocalStorage() {
      try {
        const item = localStorage.getItem(key);
        setIsLocalStorage(item ? JSON.parse(item) : []);
      } catch (err) {
        console.error("Error parsing storage", err);
        setIsLocalStorage([]);
      }
    }

    checkLocalStorage(); // Initial load

    window.addEventListener("storage", checkLocalStorage);
    return () => window.removeEventListener("storage", checkLocalStorage);
  }, [key]);

  return isLocalStorage;
};
